module.exports = __webpack_public_path__ + "img/attack_lava.a2ff520c.png";